import { Link } from 'react-router-dom'
import AppBtn, {
  AppBtnColor,
  AppBtnRadius,
  AppBtnSize,
} from '../components/btn/AppBtn'
import { useGetCurrentUserQuery } from '../core/api/UserApi'
import { Role } from '../core/api/dto/UserDto'

const User = () => {
  const { data: currentUser } = useGetCurrentUserQuery()
  if (!currentUser) {
    return null
  }

  return (
    <main className="auth-page">
      <div className="authorized">
        <Link to={'/'} className="link">
          <i className="an-ico an-ico-arrow-l" />
          <span>Вернуться к панели</span>
        </Link>
        <div className="info-user">
          <div className="name">{currentUser.username}</div>
          <div className="position">
            {Role[currentUser.userRoles.roleType[0]]}
          </div>
          <AppBtn
            path={'logout'}
            title="Выйти"
            color={AppBtnColor.outlineViolet}
            sized={AppBtnSize.lg}
            radius={AppBtnRadius.r30}
          />
        </div>
      </div>
    </main>
  )
}

export default User
